import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import OfflineCloudIcon from '../../../../../assets/images/offline-cloud.svg';
import DataSource from '../../../../../dao/DataSource/DataSource';

import './Task.scss';

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

export class Task extends React.Component {

  constructor(props) {
    super(props);

    this.state = { task: this.props.task };

    this.handleNavigateToTask = this.handleNavigateToTask.bind(this);
    this.handleTaskUpdate = this.handleTaskUpdate.bind(this);
    this.convertTaskStatus = this.convertTaskStatus.bind(this);
  }

  handleNavigateToTask(){
    if (this.props.handleClickScroll) {
      this.props.handleClickScroll();
    }
    
    this.props.history.push(`/mobile/projects-tasks/task/${this.props.task.id}`);
  }

  handleTaskUpdate(task) {
    this.setState({ task });  
  }

  componentDidMount() {
    this.taskDataSource = new DataSource('Task', this.props.task.id, { task: { build: {} } }, this.handleTaskUpdate);
    this.taskDataSource.get();
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  convertTaskStatus(status){
    return status.split('_').map(word => word.substr(0,1).toUpperCase() + word.substr(1).toLowerCase()).join(' ');
  }

  render() {
    const { project } = this.props;
    let { task } = this.state;

    if (!task) {
      task = this.props.task;
    }
    let offlineChangesIndicator;
    let completed = task.completion_criteria_counts ? task.completion_criteria_counts.completed : 0;
    let attachmentCount = task.task_attachments_count;
    const total = task.completion_criteria ? task.completion_criteria.length : 0;

    let statusText = this.convertTaskStatus(task.status);

    if (task._dirty) {
      offlineChangesIndicator = <img className="offline-indicator" src={OfflineCloudIcon} alt="changes pending"></img>;
    }

    let taskDate = null;
    if (task.estimated_completion_date || task.actual_completion_date) {
      let calendarIcon = null;
      let taskCompletion = null;
      let estimatedCompletionDate = formatDate(task.actual_completion_date ? task.actual_completion_date : task.estimated_completion_date);
      const overdue = !task.actual_completion_date && new Date(estimatedCompletionDate) < new Date() ? ' overdue' : '';
      const completed = task.status == 'not_started' || task.status == 'in_progress' ? '' : ' completed';
      calendarIcon = <div className={'calendar-icon' + overdue + completed} />;

      taskCompletion = <div className={'icon-text' + overdue}>{estimatedCompletionDate}</div>;
      const whichDatePopup = <div className="which-date-popup">{task.actual_completion_date ? 'Actual Completion Date' : 'Projected Completion Date'}</div>;

      taskDate = <div className='task-date'>
        {calendarIcon}
        {taskCompletion}
        {whichDatePopup}
      </div>;
    }

    return (
      <div className="task"  onClick={this.handleNavigateToTask}>
        <div className="task-info" >
          <div className="task-identity" >
          <div className="task-name">{task.name.toUpperCase()}</div>
            <div className="project-name">{project.name}</div>
            <div className="project-name">{task.build ? task.build.name : 'No Build'}</div>
         </div>
          <div className="img-container">
            {offlineChangesIndicator}
            <div className="right-arrow" />
          </div>
        </div>
        <div className="bottom-row">
          <div className="info-icon-row">
            <div className="attachments">
              <div className="attachment-icon" />
              <div className="icon-text">{attachmentCount}</div>
            </div>
            <div className="completion-criteria">
              <div className="completion-icon" />
              <div className="icon-text">{completed + '/' + total}
              </div>
            </div>
            {taskDate}
          </div>
          <div className="right-side">
            <div className={'task-status ' + (task.status ? task.status : '')}>{statusText}</div>
          </div>
        </div>
      </div>
    );
  }
}

Task.propTypes = {
  task: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

export default withRouter(Task);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/ProjectsTasksContainer/TaskList/Task/index.js